module.exports = __webpack_public_path__ + "static/media/8C.a46a54d9.png";